// Where someone lands after signing in (Nic 2026-10-09): Sales Reps on the
// Sales board, Onboarding Specialists on Client Onboarding, everyone else on
// the Dashboard. Anyone who also holds a broader role (admin, a manager,
// claims) lands on the Dashboard as before. The logo goes here too; Sales
// Reps and Onboarding Specialists have no Dashboard link (Nic 2026-10-12).
const BROAD_ROLES = [
  'admin',
  'director',
  'onboarding_manager',
  'claims_admin',
  'claims_manager',
  'billing_admin',
  'it_support',
];

export const homePathFor = (user) => {
  const roles = (user?._roles || []).map((r) => (typeof r === 'string' ? r : r?.roleName)).filter(Boolean);
  if (roles.some((r) => BROAD_ROLES.includes(r))) return '/dashboard';
  if (roles.includes('onboarding_support_specialist')) return '/operations/onboarding-support';
  if (roles.includes('onboarding_specialist')) return '/operations/client-onboarding';
  return '/dashboard';
};

export default homePathFor;
